// LIBRERIE/IMPORTS
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";


interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
  showSearchForm = false // Default a true se non specificato
}) => {

  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  const [pageLoad, setPageLoad] = useState<boolean>(false);

  useEffect(() => {
    // In questa maniera la pag parte senza le classi che dipendono dal caricamento, appena è carica le aggiunge (X transizioni / animazioni)
    setTimeout(setPageLoad, 500, true);
  },[])

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;

  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section className="banner bg-overlay-white-30">
            <img src="assets/images/inHome/hero.jpg" alt="villa"/>
            <p className={pageLoad ? "visible" : ""}
              dangerouslySetInnerHTML={{ __html: t('homePage.heroTitle') as string }}
            />
            {showSearchForm && <PropertySearchField searchData={{}} />}
    </section>
  );
};

export default SubHeaderHome;